import { marginTop } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const AlertContainer = styled.div `
  ${marginTop(2)};
`;
